export default __webpack_public_path__ + "static/media/generalViewDoubleWithoutSecondaryDrain.58808bab.png";